import axios from 'axios';

let appName = 'SURABAYA HAPPY'
let appVersion = '5.8.1'


// let server = 'localhost:8001'; let httpMode = 'http';
// let server = 'api-app2.mdnmaju.com'; let httpMode = 'https';
let server = 'api-app2.sbyhappy.com'; let httpMode = 'https';
// let server = 'api-app2.kamigenz.com'; let httpMode = 'https';

localStorage.setItem('serverIP', server + '/api/')
localStorage.setItem('appVersion', appVersion)
localStorage.setItem('appName', appName)
localStorage.setItem('username', '')


let serverIP = localStorage.getItem('serverIP')
    // let token = localStorage.getItem('access_token')

let serverUrl = httpMode + '://' + serverIP
localStorage.setItem('serverUrl', serverUrl)

//Bluetron
localStorage.setItem('printerIP', '127.0.0.1')

//Rest
// let serverRestIP = 'hk4.blueray-cargo.com/blueray-rest/index.php/api/';
let serverRestIP = 'localhost:9080/blueray-rest/index.php/api/';
let serverRest = httpMode + '://' + serverRestIP;
localStorage.setItem('serverRest', serverRest);


export const HTTP = axios.create({
    baseURL: serverUrl,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    }
})

HTTP.interceptors.request.use(config => {
    config.headers['X-Request-REFF'] = localStorage.getItem('X-URL-FE');

  return config;
});

export const SPARK = axios.create({
    baseURL: `http://127.0.0.1:4567/`,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
    }
})

export const RESTSERVER = axios.create({
    baseURL: 'http://127.0.0.1:9080/blueray-rest/index.php/api/',
    headers: {
        'Accept': 'application/json',
        'Access-Control-Allow-Credentials': 'true',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
        'Content-Type': 'application/json;charset=UTF-8',
    }
})



// WEBPACK FOOTER //
// ./src/components/http-lib.js